import * as types from './weaveFactorActionTypes';

const initialState = {
  weaveFactorData: null,
  weaveFactorList: [],
  createWeaveFactorData: null,
  createWeaveFactorError: null,
  updateWeaveFactorData: null,
  updateWeaveFactorError: null,
  deleteWeaveFactorData: null,
  deleteWeaveFactorError: null,
};

export const weaveFactorReducer = (state = initialState, action) => {
  switch (action.type) {
    case types.GET_WEAVEFACTOR_DATA:
      return {
        ...state,
        weaveFactorData: action.payload || null,
        weaveFactorList: action.payload?.WeaveFactorList || [],
      };
    case types.GET_WEAVEFACTOR_ERROR:
      return {
        ...state,
        weaveFactorData: null,
        weaveFactorList: [],
      };

    case types.CREATE_WEAVEFACTOR_DATA:
      return {
        ...state,
        createWeaveFactorData: action.payload,
        createWeaveFactorError: null,
      };
    case types.CREATE_WEAVEFACTOR_ERROR:
      return {
        ...state,
        createWeaveFactorData: null,
        createWeaveFactorError: action.payload,
      };

    case types.UPDATE_WEAVEFACTOR_DATA:
      return {
        ...state,
        updateWeaveFactorData: action.payload,
        updateWeaveFactorError: null,
      };
    case types.UPDATE_WEAVEFACTOR_ERROR:
      return {
        ...state,
        updateWeaveFactorData: null,
        updateWeaveFactorError: action.payload,
      };

    case types.DELETE_WEAVEFACTOR_DATA:
      return {
        ...state,
        deleteWeaveFactorData: action.payload,
        deleteWeaveFactorError: null,
      };
    case types.DELETE_WEAVEFACTOR_ERROR:
      return {
        ...state,
        deleteWeaveFactorData: null,
        deleteWeaveFactorError: action.payload,
      };

    default:
      return state;
  }
};
